import React, { useState, useEffect } from 'react';
import { format } from 'date-fns';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiClock } = FiIcons;

const TimestampDisplay = () => {
  const [currentTime, setCurrentTime] = useState(new Date());
  
  useEffect(() => {
    // Update time every minute
    const intervalId = setInterval(() => {
      setCurrentTime(new Date());
    }, 60000);
    
    // Clean up interval on unmount
    return () => clearInterval(intervalId);
  }, []);
  
  const timeString = format(currentTime, 'h:mm a');
  const dateString = format(currentTime, 'EEEE, MMMM d, yyyy');
  
  return (
    <div className="flex items-center text-gray-600 mb-4 bg-white rounded-lg p-2 shadow-sm border border-gray-200">
      <SafeIcon icon={FiClock} className="w-4 h-4 mr-2" />
      <div className="text-sm">
        <span className="font-medium">{timeString}</span>
        <span className="mx-2">•</span>
        <span>{dateString}</span>
      </div>
    </div>
  );
};

export default TimestampDisplay;